// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__vWp1o","popupContent":"Popup_popupContent__8icR2","button":"Popup_button__WqorT","input":"Popup_input__-5il8"};